import { finish, error } from 'src/modules/competitions/actions/create';

// import api from '../../../api';

export function request(dispatch, { data }) {
    console.log('data', data);
    $appState.sdkStaff.createCompetition({
        requestBody: data
    }).then(
        (competition) => dispatch(finish(competition)),
        ({ errors }) => dispatch(error(errors))
    );

    // api.post('/competitions', data).then(
    //     (competition) => dispatch(finish(competition)),
    //     ({ errors }) => dispatch(error(errors))
    // );
}
